import { ElMessage } from "element-plus";

export function useMessage(type, message) {
  ElMessage({
    message,
    type,
    duration: 5000,
    customClass: "message-box-custom-class"
  });
}
